import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/customButton";


function ScreeningStart(){


    const [isExpired, setIsTokenExpired] = useState(false);

    const navigate = useNavigate()

  return (
    <div className="container d-flex flex-column justify-content-center align-items-center min-vh-100 py-4 bg-light" style={{maxWidth:'100%'}}>
      {/* Dev toggle to test Expired State - Normally determined by backend token */}
      <div className="position-absolute top-0 end-0 p-3">
        <div className="form-check form-switch">
          <input className="form-check-input" type="checkbox" id="expireToggle" checked={isExpired} onChange={()=>setIsTokenExpired(!isExpired)} />
          <label className="form-check-label text-muted small" htmlFor="expireToggle">Mock Expired Token</label>
        </div>
      </div>


      <div className="card shadow-sm w-100" style={{ maxWidth: '500px',padding:"2px" }}>
        <div className="card-body text-center">
          <div className="mb-4">
            <div className=" text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold',backgroundColor:"#444ce7" }}>
              LL
            </div>
            <h4 className=" fw-bold h3 mb-1 text-dark mb-2">LYWO Screening</h4>
            <span className="text-lg text-muted">
              {isExpired
                ? "Your unique screening link is no longer valid."
                : `Welcome to the AI Chat Screening for the Software Developer position. Please review the instructions below before starting.`}
            </span>
          </div>


          {isExpired ? (
            <div className="d-grid gap-3">
              <div className="alert alert-warning text-start small mb-0">
                Links are valid for 7 days to ensure security and fair timing.
              </div>
              <CustomButton
                title="Request New Link"
                // handleClick={()=>[
                //     navigate('/screeningai')
                // ]}
                />
            </div>
          ) : (
            <>
              <div className="text-start mb-4 bg-white border p-3 rounded shadow-sm">
                <h6 className="fw-bold mb-3 text-dark">Before you begin:</h6>
               
                <div className="d-flex mb-3">
                  <div className="text-primary me-3 mt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-chat-dots" viewBox="0 0 16 16">
                      <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
                      <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9 9 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.4 10.4 0 0 1-.524 2.318l-.003.011a11 11 0 0 1-.244.637c-.079.186.074.394.273.362a22 22 0 0 0 .693-.125m.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6-3.004 6-7 6a8 8 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a11 11 0 0 0 .398-2"/>
                    </svg>
                  </div>
                  <div>
                    <span className="fw-semibold d-block text-dark fs-6">Interactive Format</span>
                    <small className="text-muted">This screening is conducted via an interactive chat with our AI assistant.</small>
                  </div>
                </div>


                <div className="d-flex mb-3">
                  <div className="text-primary me-3 mt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-shield-lock" viewBox="0 0 16 16">
                      <path d="M5.338 1.59a61 61 0 0 0-2.837.856.48.48 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.7 10.7 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a1 1 0 0 0 .101.025 1 1 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56"/>
                      <path d="M9.5 6.5a1.5 1.5 0 0 1-1 1.415l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99a1.5 1.5 0 1 1 2-1.415"/>
                    </svg>
                  </div>
                  <div>
                    <span className="fw-semibold d-block text-dark fs-6">Identity Verification</span>
                    <small className="text-muted">You will need your phone nearby to receive a quick verification code.</small>
                  </div>
                </div>


                <div className="d-flex">
                  <div className="text-primary me-3 mt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-clock-history" viewBox="0 0 16 16">
                      <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z"/>
                      <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z"/>
                      <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5"/>
                    </svg>
                  </div>
                  <div>
                    <span className="fw-semibold d-block text-dark fs-6">Timed Sections</span>
                    <small className="text-muted">Technical questions are timed. Ensure you have a quiet space before continuing.</small>
                  </div>
                </div>
              </div>


              <div className="d-grid gap-3">
                <CustomButton
                title="Start Screening"
                handleClick={()=>{
                  // document.documentElement.requestFullscreen()
                    navigate('/screeningai')
                }}
                />
                {/* <button className="btn btn-primary py-2 fw-semibold" 
                 onClick={()=>{
                    navigate('/screeningai')
                 }}
                >
                  Start screening
                </button> */}
              </div>
            </>
          )}
        </div>
        <div className="card-footer bg-white border-0 pb-4 text-center">
            
           <button
            className="white"
                                        // onClick={()=>setShowSubmitModal(true)}
            style={{ width: "180px", padding: "8px 14px", height: "40px" }}
            >
                Candidate Dashboard
            </button>
        </div>
      </div>
    </div>
  );
};
    

export default ScreeningStart
